<div id="navbar_header">
  <nav class="navbar navbar-expand-lg navbar-light">
    <img src="assets/logo-DANE.png" id="icon" alt="User Icon" style="width: 15%;">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="offset-md-6">
      <span><b>{{tipoUsuario}} : {{nombre}}</b></span>
    </div>
    <div class="collapse navbar-collapse offset-md"  id="navbarNavDropdown">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-user-circle fa-3x"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item">{{usuario}}</a>
            <a class="dropdown-item">{{correo}}</a>
            <a class="dropdown-item" *ngIf="CambiarContrasena=='true'" data-bs-toggle="modal" data-bs-target="#exampleModal"><b>Cambiar contraseña</b></a><!---->
            <a class="dropdown-item" (click)="onLogout()"><b>Salir</b></a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</div>

<!-- Modal Cambiar Contraseña-->
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal" style="visibility: hidden;" #openModalContrasena>Launch static backdrop modal</button>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <form>
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="exampleModalLabel" style="color: white;">Cambiar Contraseña</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

          <div class="row justify-content-center">
            <div class="col-auto"><label>Contraseña actual</label></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [(ngModel)]="ContrasenaActual"></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-auto"><label>Contraseña nueva</label></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [formControl]="PasswordNew"></div>
            <small *ngIf="PasswordNew.hasError('required') && PasswordNew.dirty">El campo es requerido</small>
            <small *ngIf="PasswordNew.hasError('pattern') && PasswordNew.dirty">La nueva contrseña debe tener mínimo de 8 caracteres, letras mayúsculas, letras minúsculas, números y símbolos</small>
          </div>
          <div class="row justify-content-center">
            <div class="col-auto"><label>Confirmar contraseña</label></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [(ngModel)]="ContrasenaConfirma"></div>
          </div>

      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-secondary" #closeModalContrasena data-bs-dismiss="modal">Cancelar</button>
        <button [disabled]="BtnCambiar" type="submit" class="btn btn-primary" (click)="verificarContrasena()">Cambiar</button> <!-- (click)="probando()" data-bs-dismiss="modal" [disabled]="PasswordNew.invalid"-->
      </div>
    </div>
    </form>
  </div>
</div>
